// extracted by mini-css-extract-plugin
module.exports = {"qaViewHolder":"QASettings_qaViewHolder__w9aL3","qaSettingsHolder":"QASettings_qaSettingsHolder__3awUr","qaSettingsOptions":"QASettings_qaSettingsOptions__2YHj5"};